<template>
	<div class="login-container">
		<el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on"
			label-position="left">
			<h3 class="title">系统登录</h3>
			<el-form-item prop="loginName">
				<el-input v-model="loginForm.loginName" placeholder="用户名" prefix-icon="el-icon-user" />
			</el-form-item>
			<el-form-item prop="password">
				<el-input v-model="loginForm.password" type="password" placeholder="密码" prefix-icon="el-icon-lock"
					show-password />
			</el-form-item>
			<el-form-item>
				<el-button :loading="loading" type="primary" @click.native.prevent="handleLogin"
					class="login-btn">登录</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	import { Message } from 'element-ui'
	import {
		login
	} from '@/api/user' // 假设接口文件路径为@/api/user.js

	export default {
		name: 'Login',
		data() {
			return {
				loginForm: {
					loginName: '19392033635',
					password: ''
				},
				loginRules: {
					loginName: [{
							required: true,
							message: '请输入用户名',
							trigger: 'blur'
						},
						{
							min: 3,
							max: 16,
							message: '长度在3到16个字符',
							trigger: 'blur'
						}
					],
					password: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '长度在6到20个字符',
							trigger: 'blur'
						}
					]
				},
				loading: false
			}
		},
		methods: {
			
			handleLogin() {
			  this.$refs.loginForm.validate(valid => {
			    if (valid) {
			      this.loading = true
			      // 方案1：直接调用API（推荐简单场景）
			      login(this.loginForm).then(res => {
					console.log(res.data)
			        localStorage.setItem('token', res.data.sessionKey)
			        this.$router.push('/businesslist')
			      }).catch(err => {
					  Message.error(err.response.data.message)
			        console.error('登录失败:', err)
			      }).finally(() => {
			        this.loading = false
			      })
			
			      // 方案2：使用Vuex（需确保action正确定义）
			      /* this.$store.dispatch('h5/login', this.loginForm)
			        .then(res => {
			          localStorage.setItem('token', res.token)
			          this.$router.push('/businesslist')
			        })
			        .catch(err => {
			          console.error('Vuex登录失败:', err)
			        })
			        .finally(() => {
			          this.loading = false
			        }) */
			    }
			  })
			}

		}
	}
</script>

<style scoped lang="less">
	.login-container {
		height: 100%;
		background: #2d3a4b;
		display: flex;
		justify-content: center;
		align-items: center;

		.login-form {
			width: 400px;
			padding: 35px;
			background: #fff;
			border-radius: 6px;
			box-shadow: 0 0 10px rgba(0, 0, 0, .1);

			.title {
				margin: 0 auto 30px;
				text-align: center;
				color: #333;
			}

			.login-btn {
				width: 100%;
			}
		}
	}
</style>